import axios from 'axios';
import { toast } from 'react-toastify';

const superAdminApiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
});

superAdminApiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('superAdminToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

superAdminApiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            toast.error("Your Super Admin session has expired or is invalid. Please log in again.");
            localStorage.removeItem('superAdminToken');
            localStorage.removeItem('superAdminInfo');
            window.location.href = '/superadmin/login';
        }
        return Promise.reject(error);
    }
);

export default superAdminApiClient;
